import { PERSONA_URL } from '../config';
import axios from 'axios';

export const getAspiranteInformacion = async (params) => {
    const url = `${PERSONA_URL}?sexo=${params.sexo}&nroDocumento=${params.nroDocumento}`;
    const result = await axios.get(url);
    return result;
};
